import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { TrackingListComponent } from '@myarvato/modules/transport/list';
import { TrackingOverviewComponent } from '@myarvato/modules/transport/overview';
import { ModuleGuard } from '@myarvato/core/guards';
import { TrackingTabsComponent } from '@myarvato/modules/transport/tabs';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'overview',
  },
  {
    path: 'overview',
    component: TrackingOverviewComponent,
    title: 'MyArvato - Transport Overview',
    canActivate: [MsalGuard, ModuleGuard],
    data: {
      breadcrumb: 'breadcrumbs.transport.overview',
      module: ['transport'],
    },
  },
  {
    path: 'list',
    component: TrackingListComponent,
    title: 'MyArvato - Transport',
    canActivate: [MsalGuard, ModuleGuard],
    data: {
      breadcrumb: 'breadcrumbs.transport.list',
      module: ['transport'],
    },
  },
  {
    path: 'tabs',
    component: TrackingTabsComponent,
    title: 'MyArvato - Transport',
    canActivate: [MsalGuard, ModuleGuard],
    data: {
      breadcrumb: 'breadcrumbs.transport.tabs',
      module: ['transport'],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TransportRoutingModule {}
